export { default as InvalidPage } from './InvalidPage';



// WEBPACK FOOTER //
// ./src/components/InvalidPage/index.ts